import * as React from 'react';
import {TwitterGenericContentType} from '@nls-2022/nls-bll';
import {createImmediateTwitterPostEntry} from '@nls-2022/nls-api';
import {BlogPostsContext} from '../../containers/blog/BlogManagerContainer';
import {BlogPostsActionType, BlogPostsAction} from '@nls-2022/nls-bll';
import {Buffer} from 'buffer';
export type TwitterPostContentDisplayType = {
  twitterPostContent: TwitterGenericContentType;
};
export const TwitterPostContentDisplay = ({
  twitterPostContent,
}: TwitterPostContentDisplayType) => {
  const blogPostsContext = React.useContext(BlogPostsContext);
  const [postGenerated, setPostGenerated] = React.useState(false);
  const [postGeneratedError, setPostGeneratedError] = React.useState(false);

  React.useEffect(() => {
    const initForm = () => {
      setPostGenerated(false);
    };
    initForm();
  }, [twitterPostContent]);

  let posts = blogPostsContext.state.blogPosts;
  let blogPostsDispatch = blogPostsContext.dispatchBlogPosts;
  const handlePostEntry = async () => {
    let base64Content = Buffer.from(
      JSON.stringify(twitterPostContent),
    ).toString('base64');
    let createPostResult = await createImmediateTwitterPostEntry(base64Content);
    if (createPostResult.success) {
      //  blogPostsDispatch({
      //    type: BlogPostsActionType.BlogPostsAddPost,
      //    actionPayload: {
      //      blogPost: createPostResult.data,
      //      blogPostId: createPostResult.data.ID,
      //    },
      //  });
      setPostGenerated(true);
    } else {
      setPostGeneratedError(true);
    }
    //console.log(newEntry);
  };
  let disablePostButton = postGenerated;
  return (
    <>
      <h3>{`Twitter Post Content`}</h3>
      <p>{`${postGenerated ? 'created post' : ''}`}</p>
      <p>{`${postGeneratedError ? 'error occurred creating post' : ''}`}</p>
      <section className="pt-6 pb-8 mb-4 px-8">
        <p className="pb-2">{twitterPostContent.content}</p>
        <button
          disabled={disablePostButton}
          onClick={handlePostEntry}
          type="submit"
          className={`h-10 bg-green-500 border-green-500  text-sm border-4 text-white py-1 px-2 rounded uppercase ${
            !disablePostButton
              ? 'hover:bg-green-700 hover:border-green-700'
              : ''
          }`}
        >
          post to twitter
        </button>
      </section>
    </>
  );
};
